import { useTranslation } from 'react-i18next';
// utils
import { localStorageAvailable } from '../utils/localStorageAvailable';
// components
import { useSettingsContext } from '../components/settings';
//
import { useCallback } from 'react';
import { allLangs, defaultLang } from './config-lang';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const settings = useSettingsContext();

  const storageAvailable = localStorageAvailable();

  const langStorage = storageAvailable ? localStorage.getItem('i18nextLng') : '';

  const currentLang = allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  // const handleChangeLanguage = (newlang: string) => {
  //   i18n.changeLanguage(newlang);
  //   settings.onChangeDirectionByLang(newlang);
  // };

  const onChangeLang = useCallback(
    (newlang: string) => {
      i18n.changeLanguage(newlang);
      settings.onChangeDirectionByLang(newlang);
    },
    [i18n, settings]
  );

  const translateWithValidNode = (text: string, options?: any) => {
    const translatedText = translate(text, options);
    if (typeof translatedText === "string") {
      return translatedText;
    }
    return text;
  };
  return {
    onChangeLang,
    translate: translateWithValidNode,
    currentLang,
    allLangs,
  };
}


// import { useTranslation } from 'react-i18next';
// import { useCallback } from 'react';
// // utils
// import { localStorageGetItem } from 'src/utils/localStorageAvailable';
// // components
// import { useSettingsContext } from 'src/components/settings';
// //
// import { allLangs, defaultLang } from './config-lang';

// // ----------------------------------------------------------------------

// export default function useLocales() {
//   const { i18n, t } = useTranslation();

//   const settings = useSettingsContext();

//   const langStorage = localStorageGetItem('i18nextLng');

//   const currentLang = allLangs.find((lang) => lang.value === langStorage) || defaultLang;

//   const onChangeLang = useCallback(
//     (newlang: string) => {
//       i18n.changeLanguage(newlang);
//       settings.onChangeDirectionByLang(newlang);
//     },
//     [i18n, settings]
//   );

//   return {
//     allLangs,
//     t,
//     currentLang,
//     onChangeLang,
//   };
// }
